import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#007F8F",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M5.7 10.2h6.6M9.9 12.6l2.4-2.4-2.4-2.4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#007F8F",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M3 3.6a1.2 1.2 0 0 0-1.2 1.2V15A1.2 1.2 0 0 0 3 16.2h12a1.2 1.2 0 0 0 1.2-1.2V4.8A1.2 1.2 0 0 0 15 3.6zM4.8 1.8v3.6M13.2 1.8v3.6"
    }, null, -1)
  ])))
}
export default { render: render }